export var NodeKind;
(function (NodeKind) {
    NodeKind[NodeKind["Top"] = 0] = "Top";
    NodeKind[NodeKind["Internal"] = 1] = "Internal";
    NodeKind[NodeKind["Bottom"] = 2] = "Bottom";
})(NodeKind || (NodeKind = {}));
//# sourceMappingURL=NodeKind.js.map